import Toasted from 'vue-toasted';

export default function initialiseToasts( Vue ) {
	Vue.use( Toasted, {
		theme: 'toasted-primary',
	} );

	Vue.toasted.register(
		'error',
		payload => payload || 'Error',
		{
			type: 'error',
			// icon: 'fa-times-circle',
			duration: 3000,
			action: {
				text: 'Close',
				onClick: ( e, toastObject ) => toastObject.goAway( 0 ),
			},
		}
	);

	Vue.toasted.register(
		'errorPermanent',
		payload => payload || 'Error',
		{
			type: 'error',
			// icon: 'fa-times-circle',
			action: {
				text: 'Close',
				onClick: ( e, toastObject ) => toastObject.goAway( 0 ),
			},
		}
	);

	Vue.toasted.register(
		'success',
		payload => payload || 'Success',
		{
			type: 'success',
			// icon: 'fa-check-circle',
			duration: 3000,
			action: {
				text: 'Close',
				onClick: ( e, toastObject ) => toastObject.goAway( 0 ),
			},
		}
	);
}
